import {
  Calendar03Icon,
  CustomerSupportIcon,
  CreditCardIcon,
  DashboardSquare01Icon,
  File01Icon,
  Flag01Icon,
  Globe02Icon,
  Layout03Icon,
  Mail01Icon,
  Megaphone01Icon,
  Notification01Icon,
  Search01Icon,
  Settings01Icon,
  Shield01Icon,
  SecurityIcon,
  SparklesIcon,
  UserGroupIcon,
  UserGroup02Icon,
  UserSettings01Icon,
} from '@hugeicons/core-free-icons';
import type { ConsoleNavGroup, ConsoleNavItem } from '../components/layout/console-sidebar';
import type { SocialNavItem } from '../components/layout/social-sidebar';

export const adminBrand = {
  title: 'Loamify Admin',
  subtitle: 'Platform Operations',
  href: '/dashboard',
  mark: 'A',
};

export const adminTopNav: ConsoleNavItem[] = [
  { label: 'Dashboard', href: '/dashboard', icon: DashboardSquare01Icon },
];

/** Admin navigation — operational density (vision.md). */
export const adminNavGroups: ConsoleNavGroup[] = [
  {
    label: 'Management',
    items: [
      { label: 'Users', href: '/users', icon: UserGroupIcon },
      { label: 'Creators', href: '/creators', icon: UserSettings01Icon },
      { label: 'Circles', href: '/circles', icon: UserGroup02Icon },
      { label: 'Courses', href: '/courses', icon: File01Icon },
      { label: 'Articles', href: '/articles', icon: File01Icon },
      { label: 'Events', href: '/events', icon: Calendar03Icon },
      { label: 'Memberships', href: '/memberships', icon: File01Icon },
      { label: 'Offers', href: '/offers', icon: SparklesIcon },
      { label: 'Creator sites', href: '/creator-sites', icon: Layout03Icon },
      { label: 'Discovery', href: '/discovery', icon: Search01Icon },
      { label: 'Moderation', href: '/moderation', icon: Shield01Icon },
      { label: 'Reports', href: '/reports', icon: Flag01Icon },
      { label: 'Appeals', href: '/appeals', icon: Shield01Icon },
      { label: 'Legal requests', href: '/legal-requests', icon: File01Icon },
      { label: 'Support inbox', href: '/support', icon: CustomerSupportIcon },
      { label: 'Audience CRM', href: '/audience', icon: UserGroupIcon },
    ],
  },
  {
    label: 'Platform',
    items: [
      { label: 'Billing', href: '/billing', icon: CreditCardIcon },
      { label: 'Disputes', href: '/disputes', icon: CreditCardIcon },
      { label: 'Marketing ops', href: '/marketing', icon: Megaphone01Icon },
      { label: 'Site settings', href: '/settings', icon: Settings01Icon },
      { label: 'Notifications', href: '/notifications', icon: Notification01Icon },
      { label: 'Email Templates', href: '/email-templates', icon: Mail01Icon },
      { label: 'Feature Flags', href: '/feature-flags', icon: SparklesIcon },
      { label: 'Security', href: '/security', icon: SecurityIcon },
      { label: 'Domains', href: '/domains', icon: Globe02Icon },
      { label: 'Audit Logs', href: '/audit-logs', icon: File01Icon },
    ],
  },
];

function toSocialNav(items: ConsoleNavItem[]): SocialNavItem[] {
  return items.map(({ label, href, icon, badge }) => ({ label, href, icon, badge }));
}

/** Flat social sidebar nav for PeerlistShell. */
export const adminMainNav: SocialNavItem[] = [
  ...toSocialNav(adminTopNav),
  ...toSocialNav(adminNavGroups[0]?.items ?? []),
];

export const adminSecondaryNav: SocialNavItem[] = toSocialNav(adminNavGroups[1]?.items ?? []);
